export class DroppedScreenService {
    constructor($injector) {
        this.$injector = $injector;
        this.$rootScope = this.$injector.get('$rootScope');
        this.$translate = this.$injector.get('$translate');
    }
}
